import { AlertTriangle } from 'lucide-react';
import { Button } from '@/shared/components';

export function CommunicationConflict({
  dirty,
  reloadFailed = false,
  onReload,
}: {
  dirty: boolean;
  /** Der letzte Ladeversuch scheiterte — der Entwurf ist deshalb unverändert geblieben. */
  reloadFailed?: boolean;
  onReload: () => void;
}) {
  return (
    <div
      role="alert"
      className="border-amber/40 bg-amber-soft text-ink flex w-full flex-col gap-3 rounded-lg border p-4 min-[600px]:flex-row min-[600px]:items-center min-[600px]:justify-between"
    >
      <span>
        <AlertTriangle className="mr-2 inline size-4" aria-hidden />
        Jemand hat die Nachrichten inzwischen geändert. Laden Sie den aktuellen Stand, bevor Sie
        weiterarbeiten.{dirty && ' Ungespeicherte Texte gehen dabei verloren.'}
        {reloadFailed && (
          <b className="mt-1 block">
            Der aktuelle Stand konnte nicht geladen werden – Ihre Texte bleiben erhalten. Bitte
            versuchen Sie es erneut.
          </b>
        )}
      </span>
      <Button type="button" className="min-h-11 shrink-0" onClick={onReload}>
        Aktuellen Stand laden
      </Button>
    </div>
  );
}
